/**
 * Color palette primitives for the Brand 2026 Customer theme.
 *
 * @remarks
 * Prefer using the color theme tokens instead, as they are more stable and less likely to change.
 */
export const palette = {
  purpleBase: '#51285F',
  purple70: '#7E6389',
  purple50: '#A894AF',
  purple30: '#D1C3D5',
  purple10: '#EEE9EF',
  purple5: '#F6F4F7',
  neutralWhite: '#FFFFFF',
  neutralOffWhite: '#FEFBF7',
  neutralProductBlack: '#0E0E11',
  neutralBrandBlack: '#3B3B41',
  greyBase: '#75757C',
  grey70: '#9A9A9F',
  grey50: '#BABABD',
  grey30: '#D9D9DB',
  grey10: '#F1F1F2',
  grey5: '#F8F8F8',
  deepPurpleShade30: '#1F0C25',
  deepPurpleShade20: '#271030',
  deepPurpleBase: '#31153C',
  deepPurple70: '#634D6C',
  deepPurple50: '#9B8A9E',
  deepPurple30: '#CDC6CF',
  deepPurple10: '#ECEAED',
  deepPurple5: '#F6F4F6',
  blueShade30: '#0A3644',
  blueShade20: '#0F4457',
  blueBase: '#135A72',
  blue50: '#69ACB9',
  blue30: '#B8CDD5',
  blue10: '#E7EFF2',
  blue5: '#F3F7F9',
  greenBase: '#17830F',
  green50: '#8BC187',
  green30: '#BFDDBD',
  green10: '#E8F3E7',
  yellowBase: '#F6BB25',
  yellow50: '#FADD92',
  yellow30: '#FCECC4',
  yellow10: '#FEF7E8',
  yellow5: '#FEF9F1',
  redBase: '#B01518',
  red50: '#D78A8B',
  red30: '#E6B7B8',
  red10: '#F5E4E4',
  red5: '#FAF1F1',
} as const;
